
export class DisplayText {
    key: string | number | boolean | any;
    value: string;

    constructor(key: string | number | boolean, value: string) {
        this.key = key;
        this.value = value;
    }
}
